import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    TextField,
} from '@mui/material'
import React, { useState } from 'react'
import { Container } from './styles'
import { UnidadeRecebivelProtocol } from '../../Pages/Pagamento/interfaces'
import toast from 'react-hot-toast'
import { useSelector } from 'react-redux'
import { StoreState } from '../../store'
import { useDispatch } from 'react-redux'
import * as actions from '../../store/modules/cerc/actions'

interface FormDialogProps {
    open: boolean
    setOpen: (valor: boolean) => void
    unidadeRecebivel: UnidadeRecebivelProtocol
}

const FormDialog: React.FC<FormDialogProps> = ({
    open,
    setOpen,
    unidadeRecebivel,
}) => {
    const { unidadesRecebiveisSelecionadas } = useSelector(
        (state: StoreState) => state.cerc
    )
    const dispatch = useDispatch()
    const [newValue, setNewValue] = useState('')
    const handleClose = () => {
        setOpen(false)
    }

    function handleSubmit() {
        // const value = newValue.replace(',', '.')
        const value = newValue.replace(',', '.')
        if (isNaN(Number(value))) {
            toast.error('Digite um valor válido')
            return
        }
        if (Number(value) <= 0 || !value) {
            toast.error('Digite um valor válido')
            return
        }

        if (Number(value) > Number(unidadeRecebivel.valorLivre)) {
            toast.error(
                'Novo valor precisa ser menor ou igual ao valor disponível'
            )
            return
        }

        if (
            unidadesRecebiveisSelecionadas.some(
                (unidadeR) => unidadeR.id === unidadeRecebivel.id
            )
        ) {
            dispatch(actions.cercRemoveUR(unidadeRecebivel.id))
        }

        dispatch(
            actions.cercAddUR({
                id: unidadeRecebivel.id,
                agendaId: unidadeRecebivel.agendasId,
                instituicaoCredenciadora:
                    unidadeRecebivel.agendas?.instituicaoCredenciadora,
                codigoArranjoPagamento:
                    unidadeRecebivel.agendas?.codigoArranjoPagamento,
                constituicao: unidadeRecebivel.constituicao,
                dataLiquidacao: unidadeRecebivel.dataLiquidacao,
                valorTotalUR: unidadeRecebivel.valorTotalUR,
                valorConstituidoAntecipacaoPre:
                    unidadeRecebivel.valorConstituidoAntecipacaoPre,
                valorConstituidoTotal: unidadeRecebivel.valorConstituidoTotal,
                valorBloqueado: unidadeRecebivel.valorBloqueado,
                valorLivre: unidadeRecebivel.valorLivre,
                valorLivreSelecionado: value,
            })
        )

        setNewValue('')
        handleClose()
    }
    return (
        <Container>
            <Dialog open={open} onClose={handleClose}>
                <DialogTitle>Escolher novo valor</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        Escolha um novo valor para transferir dessa unidade
                        recebível
                    </DialogContentText>
                    <DialogContentText>
                        Valor disponível: R${' '}
                        {Number(unidadeRecebivel.valorLivre).toLocaleString()}
                    </DialogContentText>
                    <TextField
                        autoFocus
                        margin="dense"
                        id="name"
                        label="R$"
                        type="text"
                        value={newValue}
                        onChange={(e) => setNewValue(e.target.value)}
                        fullWidth
                        variant="standard"
                    />
                    <DialogContentText fontSize={12}>
                        Digite números com no máximo duas casas decimais
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose}>Cancelar</Button>
                    <Button onClick={handleSubmit}>Adicionar e salvar</Button>
                </DialogActions>
            </Dialog>
        </Container>
    )
}

export default FormDialog
